module.exports = __webpack_public_path__ + "static/media/notfound.5e99ae96.png";